import { useQuery } from '@tanstack/react-query';
import { rbacService } from '../../services/rbac/rbacService';
import { queryKeyFactory } from '../../services/core/queryKeys';
import { getPresetOptions } from './createDataQuery';

export function useCurrentUser(userOid: string | null, enabled: boolean) {
  return useQuery({
    queryKey: queryKeyFactory.rbac.currentUser(userOid),
    queryFn: () => rbacService.getCurrentUser(),
    enabled: enabled && !!userOid,
    ...getPresetOptions('default'),
    // Права восстанавливаются из localStorage для мгновенного рендера, но при
    // каждом запуске приложения перепроверяются: выдача прав SQL-скриптом или
    // другим администратором не должна ждать истечения staleTime.
    refetchOnMount: 'always',
    retry: (failureCount, error) => {
      if (error instanceof Error) {
        const msg = error.message;
        if (msg.includes('401') || msg.includes('403')) return false;
      }
      return failureCount < 2;
    },
  });
}
